export default __webpack_public_path__ + "static/media/non_actif_trame.8cf6fae5.svg";